<template>
  <section class="flex items-center" v-if="license">
    <span class="p-1 hidden">-</span>
    <div :class="['license', license]">{{license}}
      <div class="license-icon"></div>
    </div>
  </section>
</template>

<script src="./player-setup-license-icon.js"></script>
<style lang="scss" src="./player-setup-license-icon.scss"></style>
